import { Component, Input, OnInit } from '@angular/core';
import { trackByRoute } from '../../utils/track-by';
import { NavigationService } from '../../services/theme/navigation.service';
import icRadioButtonChecked from '@iconify/icons-ic/twotone-radio-button-checked';
import icRadioButtonUnchecked from '@iconify/icons-ic/twotone-radio-button-unchecked';
import twotoneKeyboardArrowLeft from '@iconify/icons-ic/twotone-keyboard-arrow-left';
import twotoneKeyboardArrowRight from '@iconify/icons-ic/twotone-keyboard-arrow-right';
import { LayoutService } from '../../services/theme/layout.service';
import { ConfigService } from '../../services/theme/config.service';
import { map } from 'rxjs/operators';
import { ThemeService } from 'src/@core/services/theme.service';

@Component({
  selector: 'codemiro-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {

  @Input() collapsed: boolean;
  collapsedOpen$ = this.layoutService.sidenavCollapsedOpen$;
  title$ = this.configService.config$.pipe(map(config => config.sidenav.title));
  imageUrl$: any = this.configService.config$.pipe(map(config => config.sidenav.imageUrl));
  showCollapsePin$ = this.configService.config$.pipe(map(config => config.sidenav.showCollapsePin));

  items = this.navigationService.items;
  trackByRoute = trackByRoute;
  icRadioButtonChecked = icRadioButtonChecked;
  icRadioButtonUnchecked = icRadioButtonUnchecked;
  twotoneKeyboardArrowLeft = twotoneKeyboardArrowLeft;
  twotoneKeyboardArrowRight = twotoneKeyboardArrowRight;

  constructor(private navigationService: NavigationService,
    private layoutService: LayoutService,
    private configService: ConfigService,
    public themeService: ThemeService) { }

  ngOnInit() {
  }

  onMouseEnter() {
    // Collapsed means icons only: the toggle expands it, hovering does not
    // spread the menu over the page.
  }

  onMouseLeave() {
    this.layoutService.collapseCloseSidenav();
  }

  toggleCollapse() {
    this.layoutService.toggleSidenavCollapsed();
  }
}
